import { Injectable, OnDestroy } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import * as _ from "lodash";
import { IClient, IVendor, IClients, IJobSubmission } from 'portalServices';
import { HttpClient } from '@angular/common/http';
import { FormMetaData } from '../inteface';
import { CONSTANTS } from 'app/common/contants';
import { filter, share, map, take } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';
import moment from 'moment';
import { AppServices } from 'app/servicelayer/app-services';
import { DateUtilityService } from '../services/date-utility.service';

@Injectable({
    providedIn: 'root'
})
export class FormService implements OnDestroy {
    metaData: FormMetaData;
    formMetaData: any;
    form: FormGroup;
    isLoaded: boolean = false;
    subscriptions: Subscription[] = [];

    // Subject to notify when metadata is loaded
    private metaDataLoaded$ = new Subject<FormMetaData>();
    public onMetaDataLoaded = this.metaDataLoaded$.asObservable();

    // Subject to notify when field options are updated by async formulas
    public fieldOptionsUpdated = new Subject<string[]>();

    constructor(
        private http: HttpClient,
        private appServices: AppServices,
        private dateUtility: DateUtilityService
    ) { }

    public get configService() { return this.appServices.configService; }
    public get clientService() { return this.appServices.clientService; }
    public get vendorService() { return this.appServices.vendorService; }
    public get downloadService() { return this.appServices.downloadService; }
    public get hmFlowService() { return this.appServices.hmFlowService; }

    //TODO need to migrate to backend
    getFormData() {
        const url = `./assets/app.json?cachebuster=${new Date().getTime()}`;
        this.http.get(url).subscribe((data: FormMetaData) => {
            this.metaData = data;
            this.isLoaded = true;
            this.metaDataLoaded$.next(data);
            console.log('✅ FormService - Metadata loaded successfully');
        }, error => {
            console.error('❌ FormService - Failed to load metadata:', error);
        });
    }

    getDownloadFile(filePath: string) //Todo 
    {
        var sub = this.downloadService.getDocumentFile(filePath)
            .subscribe((data: any) => {
                const url = window.URL.createObjectURL(new Blob([data.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.pdf');
                document.body.appendChild(link);
                link.click();
            });
        this.subscriptions.push(sub);
    }

    getViewFileUrl(filePath: string): any {
        return this.downloadService.getViewFileUrl(filePath).pipe(share());
    }

    executeFormula(formulas) {
        formulas.forEach(formula => {
            if (formula.action == CONSTANTS.ACTION_SUBSTRING) {
                var subString = '';
                var isConditionValid = true;
                for (let i = 0; i < formula.fields.length; i++) {
                    let value = this.form.controls[formula.fields[i].name].value;
                    let lookUpList = this.configService.configData[formula.fields[i].lookUpValue] || [];
                    lookUpList.forEach(lookUp => {
                        if (lookUp[formula.fields[i].key] == value) {
                            value = lookUp[formula.fields[i].value];
                        }
                    });
                    if (value == '') {
                        isConditionValid = false;
                        break;
                    }
                    if (i == 0) {
                        subString = value.substring(formula.fields[i].initial, formula.fields[i].final);
                    }
                    else {
                        subString = subString + '-' + value.substring(formula.fields[i].initial, formula.fields[i].final);
                    }
                }
                if (isConditionValid) {
                    formula.actionField.forEach(field => {
                        this.form.patchValue({
                            [field.name]: subString
                        });
                        this.form.controls[field.name].disable();
                    });
                }
            }
            else if (formula.action == CONSTANTS.ACTION_SUBLOOKUP) {
                let id = this.form.controls[formula.lookUpValue.fieldName].value;
                let lookUpList = this.configService.configData[formula.lookUpValue.lookUpValue] || [];

                let lookUp = lookUpList.find(lookUpitem => lookUpitem[formula.lookUpValue.fieldName].toString() === id.toString());

                formula.lookUpValue.subLookUpValue.forEach(subLookUp => {
                    let newList = [];
                    let options = lookUp ? lookUp[subLookUp.name] : [];
                    options.forEach(list => {
                        let val;

                        subLookUp.value.forEach(value => {
                            if (list[value]) {
                                val = val ? val + ',' + list[value] : list[value];
                            }
                        });
                        let obj = {
                            key: list[subLookUp.key],
                            value: val
                        };
                        newList.push(obj);
                    });
                    this.formMetaData.forEach(field => {
                        if (field.controlName == subLookUp.key || field.controlName === subLookUp.mappingkey) {
                            field.options = newList;
                        }
                    });
                });
                
                // Notify that field options have been updated for synchronous lookup
                const updatedFieldNames = formula.lookUpValue.subLookUpValue.map(sub => sub.mappingkey || sub.key);
                this.fieldOptionsUpdated.next(updatedFieldNames);

            }
            else if (formula.action === CONSTANTS.ACTION_ASYNC) {
                if (formula.actionCall === CONSTANTS.CLIENT_DETAILS_ASYNC) {
                    let id = this.form.controls[formula.lookUpValue.fieldName].value;
                    this.clientService.getSelectedClientById(id);
                    var sub = this.clientService.selectedClient
                        .pipe(
                            filter((client: IClient) => !!client && client.clientId === id),
                            take(1),
                            map((client: IClient) => {
                                formula.lookUpValue.subLookUpValue.forEach(subLookUp => {
                                    let newList = [];
                                    let options = client.clientAddress ? client.clientAddress : [];
                                    options.forEach(list => {
                                        let val;

                                        subLookUp.value.forEach(value => {
                                            if (list[value]) {
                                                val = val ? val + ',' + list[value] : list[value];
                                            }
                                        });
                                        let obj = {
                                            key: list[subLookUp.key],
                                            value: val
                                        };
                                        newList.push(obj);
                                    });
                                    this.formMetaData.forEach(field => {
                                        if (field.controlName == subLookUp.key) {
                                            field.options = newList;
                                        }
                                    });
                                });
                                
                                // Notify that field options have been updated
                                const updatedFieldNames = formula.lookUpValue.subLookUpValue.map(sub => sub.mappingkey || sub.key);
                                this.fieldOptionsUpdated.next(updatedFieldNames);
                            })
                        ).subscribe();
                    this.subscriptions.push(sub);
                }
                else if (formula.actionCall === CONSTANTS.VENDOR_DETAILS_ASYNC) {
                    let id = this.form.controls[formula.lookUpValue.fieldName].value;

                    this.vendorService.getSelectedVendorById(id);
                    var sub = this.vendorService.selectedVendor
                        .pipe(
                            filter((vendor: IVendor) => !!vendor && vendor.vendorId === id),
                            take(1),
                            map((vendor: IVendor) => {
                                formula.lookUpValue.subLookUpValue.forEach(subLookUp => {
                                    let newList = [];
                                    let options = vendor.vendorContacts ? vendor.vendorContacts : [];
                                    options.forEach(list => {
                                        let val;

                                        subLookUp.value.forEach(value => {
                                            if (list[value]) {
                                                val = val ? val + ',' + list[value] : list[value];
                                            }
                                        });
                                        let obj = {
                                            key: list[subLookUp.key],
                                            value: val
                                        };
                                        newList.push(obj);
                                    });
                                    this.formMetaData.forEach(field => {
                                        if (field.controlName == subLookUp.key) {
                                            field.options = newList;
                                        }
                                    });

                                });
                                
                                // Notify that field options have been updated
                                const updatedFieldNames = formula.lookUpValue.subLookUpValue.map(sub => sub.mappingkey || sub.key);
                                this.fieldOptionsUpdated.next(updatedFieldNames);
                            })
                        ).subscribe();
                    this.subscriptions.push(sub);
                }

                else if (formula.actionCall === CONSTANTS.CLIENTSPOCCLIENT_ASYNC) {
                    let id = this.form.controls[formula.lookUpValue.fieldName].value;
                    this.hmFlowService.getClientSpocClientDetailsById(id);
                    var sub = this.hmFlowService.selectedClientspocClient
                        .pipe(
                            filter((client: IClients) => !!client && client.clientId === id),
                            take(1),
                            map((client: IClients) => {
                                formula.lookUpValue.subLookUpValue.forEach(subLookUp => {
                                    let newList = [];
                                    let options = client.clientSpocs.filter((spoc) => spoc.status == true);
                                    options.forEach(list => {
                                        let val;

                                        subLookUp.value.forEach(value => {
                                            if (list[value]) {
                                                val = val ? val + ',' + list[value] : list[value];
                                            }
                                        });
                                        let obj = {
                                            key: list[subLookUp.key],
                                            value: val
                                        };
                                        newList.push(obj);
                                    });
                                    this.formMetaData.forEach(field => {
                                        if (field.controlName == subLookUp.key) {
                                            field.options = newList;
                                        }
                                    });
                                });
                                
                                // Notify that field options have been updated
                                const updatedFieldNames = formula.lookUpValue.subLookUpValue.map(sub => sub.mappingkey || sub.key);
                                this.fieldOptionsUpdated.next(updatedFieldNames);
                            })
                        ).subscribe();
                    this.subscriptions.push(sub);
                }
                else if (formula.actionCall === CONSTANTS.JS_PA_ASYNC) {
                    let id = this.form.controls[formula.lookUpValue.fieldName].value;
                    this.hmFlowService.getJobSubmissionById(id);
                    var sub = this.hmFlowService.selectedJobSubmission
                        .pipe(
                            filter((jobSubmission: IJobSubmission) => !!jobSubmission && jobSubmission.jobSubmissionId === id),
                            take(1),
                            map((jobSubmission: IJobSubmission) => {
                                formula.lookUpValue.subLookUpValue.forEach(subLookUp => {
                                    let newList = [];
                                    let options = jobSubmission.interviewPanelAvailabilities ? jobSubmission.interviewPanelAvailabilities : [];
                                    options.forEach(list => {
                                        let val;

                                        subLookUp.value.forEach(value => {
                                            if (list[value]) {
                                                val = val ? val + ',' + list[value] : list[value];
                                            }
                                        });
                                        val = this.appendPanelSlot(val, list);
                                        const gaps = this.getFreeGaps(list);
                                        if (gaps === null) {
                                            newList.push({ key: list[subLookUp.key], value: val });
                                            return;
                                        }
                                        if (gaps.length === 0) {
                                            return;
                                        }
                                        const freeText = gaps.map(g => `${this.toTwelveHour(g.start)} - ${this.toTwelveHour(g.end)}`).join(', ');
                                        newList.push({
                                            key: list[subLookUp.key],
                                            value: `${this.appendPanelSlot(val.split(' | ')[0], { availableDate: list.availableDate })} | Free: ${freeText}`
                                        });
                                        return;
                                        let obj = {
                                            key: list[subLookUp.key],
                                            value: val
                                        };
                                        newList.push(obj);
                                    });
                                    this.formMetaData.forEach(field => {
                                        if (field.controlName == subLookUp.key) {
                                            field.options = newList;
                                        }
                                    });
                                });
                                
                                // Notify that field options have been updated
                                const updatedFieldNames = formula.lookUpValue.subLookUpValue.map(sub => sub.mappingkey || sub.key);
                                this.fieldOptionsUpdated.next(updatedFieldNames);
                            })
                        ).subscribe();
                    this.subscriptions.push(sub);
                }
            }
        });
    }

    private getFreeGaps(panel: any): { start: string, end: string }[] | null {
        if (!panel || !panel.startTime || !panel.endTime) {
            return null;
        }
        const toMin = (t: string) => {
            const p = String(t).split(':');
            return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10);
        };
        const toStr = (m: number) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}:00`;
        const booked = (panel.jobInterviews || [])
            .filter((i: any) => i.startTime && i.endTime)
            .map((i: any) => ({ s: toMin(i.startTime), e: toMin(i.endTime) }))
            .sort((a, b) => a.s - b.s);
        const gaps: { start: string, end: string }[] = [];
        let cursor = toMin(panel.startTime);
        const end = toMin(panel.endTime);
        booked.forEach(b => {
            if (b.s > cursor) {
                gaps.push({ start: toStr(cursor), end: toStr(Math.min(b.s, end)) });
            }
            cursor = Math.max(cursor, b.e);
        });
        if (cursor < end) {
            gaps.push({ start: toStr(cursor), end: toStr(end) });
        }
        return gaps;
    }

    private appendPanelSlot(label: string, panel: any): string {
        if (!panel || !panel.availableDate) {
            return label;
        }
        const date = new Date(panel.availableDate);
        const dateText = isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
        const start = this.toTwelveHour(panel.startTime);
        const end = this.toTwelveHour(panel.endTime);
        const time = start && end ? `${start} - ${end}` : (start || end || '');
        return [label, dateText, time].filter(Boolean).join(' | ');
    }

    private toTwelveHour(time: string): string {
        if (!time) {
            return '';
        }
        const parts = String(time).split(':');
        const h = parseInt(parts[0], 10);
        if (isNaN(h)) {
            return '';
        }
        return `${String(h % 12 === 0 ? 12 : h % 12).padStart(2, '0')}:${(parts[1] || '00').padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
    }

    changeDateToApiFormula(date: Date | any): Date {
        // Use the centralized date utility for timezone-safe Date object formatting
        return this.dateUtility.formatForAPI(date);
    }

    changeDateToApiFormulaTest(date: Date | any): string {
        // Use the centralized date utility for consistent MM/DD/YYYY formatting
        const formatted = this.dateUtility.toMMDDYYYYString(date);
        return formatted || '';
    }

    applyLookUp(formulas: any) {
        // Implementation for lookup formulas - keeping existing functionality
        // This method was referenced in the code but needs implementation
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.fieldOptionsUpdated.complete();
    }
}